import React from 'react';
import { Box } from '@mui/material';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { loadAudioAsync } from '@monorepo/shared/src/util/activity-audio-util';
import useRewardsStore from 'graph/state/query-hooks/use-rewards-store';
import rewardsButton from 'assets/images/rewards-button.png';
import rewardsSelectedButton from 'assets/images/rewards-selected-button.png';
import ImageButton from './ImageButton';
import { AppRoutes } from 'types';

const t = (key: string) => translate('a11y', key);

type Props = {
  styles?: React.CSSProperties;
  components?: any;
  noRedirect?: string;
};

const RewardsButton: React.FC<Props> = ({ styles, components, noRedirect, ...rest }) => {
  const [{ instructions, loading, error }] = useRewardsStore();

  const handleOnClick = async () => {
    if (instructions && !loading && !error) {
      const sound = await loadAudioAsync(instructions);
      sound && sound.play();
    }
  };

  return (
    <Box style={styles}>
      <ImageButton
        hoveredImgSrc={rewardsSelectedButton}
        notHoveredImgSrc={rewardsButton}
        imgAlt={t('alt.rewardsButton')}
        onClick={handleOnClick}
        redirectRoute={
          noRedirect
            ? undefined
            : { path: `/${AppRoutes.REWARDS}`, title: AppRoutes.REWARDS as any }
        }
        {...rest}
      />
      {components && <div>{components}</div>}
    </Box>
  );
};

export default RewardsButton;
